<template>

  <div>
    <h2>Общий табель по ДО</h2>

    <div class="row col-md-7">
      <div class="el-input-group">
        <label for="bin" class="form-label col-md-3">БИН</label>
        <div class="col-md-9">
          <div class="input-group">
            <input type="text" class="form-control" id="bin" v-model="searchParams.bin">
          </div>
        </div>
      </div>
    </div>

    <div class="row col-md-7">
      <div class="el-input-group">
        <label for="lmsId" class="form-label col-md-3">LMS ID</label>
        <div class="col-md-9">
          <div class="input-group">
            <input type="text" class="form-control" id="lmsId" v-model="searchParams.lmsId">
          </div>
        </div>
      </div>
    </div>

    <div class="row col-md-7">
      <div class="el-input-group">
        <label for="lmsId" class="form-label col-md-3">Название ДО</label>
        <div class="col-md-9">
          <div class="input-group">
            <input type="text" class="form-control" id="kindergartenName" v-model="searchParams.kindergartenName">
          </div>
        </div>
      </div>
    </div>

    <div class="row col-md-7">
      <div class="el-input-group">
        <label for="accountingMonth" class="form-label col-md-3">Расчетный месяц</label>
        <div class="col-md-9">
          <div class="input-group">
            <input type="number" max="12" class="form-control" id="accountingMonth"
                   v-model="searchParams.accountingMonth">
          </div>
        </div>
      </div>
    </div>

    <div class="row col-md-7">
      <div class="el-input-group">
        <label for="accountingYear" class="form-label col-md-3">Расчетный год</label>
        <div class="col-md-9">
          <div class="input-group">
            <input type="number" min="2024" class="form-control" id="accountingYear"
                   v-model="searchParams.accountingYear">
          </div>
        </div>
      </div>
    </div>

    <div class="row col-md-7">
      <div class="el-input-group">
        <label for="kato" class="form-label col-md-3">Населенный пункт</label>
        <div class="col-md-9">
          <div class="input-group">
            <!--              <input type="text" @change="fetchDirectoryList(true)" class="form-control" id="kato" v-model="searchParams.kato" />-->
            <multiselect
                v-model="kato"
                :options="katoList"
                :searchable="true"
                :closeOnSelect="true"
                track-by="code"
                :custom-label="formattedKatoLabel"
                placeholder="Выберите Като"
                :multiple="false"
                :clear-on-select="true"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row col-md-7">
      <div class="el-input-group">
        <button class="btn btn-primary" @click="fetchTimesheetData" :disabled="fetchLoading">
          {{ !fetchLoading ? "Поиск" : "Загрузка..." }}
        </button>
      </div>
    </div>

    <div class="page-content-info d-flex align-items-center justify-content-end">
      <button :disabled="(timesheetGeneralResponse.length === 0)" class="btn btn-info"
              @click="downloadGeneratedCalculationReportList()">Выгрузить результат по фильтру
      </button>
    </div>


    <div class="row">
      <div class="col-md-2"><span>Элементов: {{ timesheetGeneralResponse.length }}</span></div>
      <div v-if="hasAccess(adminRoles)" class="col-md-2"><span>Выбрано: {{ selectionTimesheetDataList.length }}</span>
      </div>
      <div v-if="hasAccess(adminRoles)" class="col-md-4">
        <button v-if="selectionTimesheetDataList.length > 0" type="button" class="btn btn-danger"
                @click="showDeleteConfirmationModal = true">Удалить выбранные элементы
          ({{ selectionTimesheetDataList.length }})
        </button>
      </div>
    </div>

    <DeleteReasonDialog v-model="showDeleteConfirmationModal" title="Вы точно хотите удалить выбранные строки из табеля?" :loading="fetchLoading" @confirm="handleDeleteSelectedElements">
      <p>Выбрано строк: {{ selectionTimesheetDataList.length }}. После удаления табель будет пересчитан.</p>
    </DeleteReasonDialog>
    <el-table
        ref="multipleTableRef"
        @selection-change="handleSelectionChange"
        :data="timesheetGeneralResponse"
        style="width: 100%"
        border
        height="95vh">
      <el-table-column v-if="hasAccess(adminRoles)" type="selection"/>
      <el-table-column type="index" label="#"></el-table-column>
      <el-table-column prop="accountingMonth" label="Расчетный месяц"></el-table-column>
      <el-table-column prop="accountingYear" label="Расчетный год"></el-table-column>
      <el-table-column prop="bin" label="БИН ДО"></el-table-column>
      <el-table-column prop="lmsId" label="LMS ID"></el-table-column>
      <el-table-column prop="kindergartenName" label="Наименование ДО"></el-table-column>
      <el-table-column prop="lmsName" label="Наименование LMS системы"></el-table-column>
      <el-table-column prop="totalDaysInMonth" label="Общее количество дней в месяце"></el-table-column>
      <el-table-column prop="workingDays" label="Рабочие дни в месяце"></el-table-column>
      <el-table-column prop="weekendDays" label="Выходные и праздничные дни в месяце"></el-table-column>
      <el-table-column prop="excusedAbsenceDays" label="Отсутствие по уважительной причине"></el-table-column>
      <el-table-column prop="unexcusedAbsenceDays" label="Отсутствие по неуважительной причине"></el-table-column>
      <el-table-column prop="presenceDays" label="Дни присутствия"></el-table-column>
      <el-table-column prop="sickLeaveDays" label="Больничный"></el-table-column>
      <el-table-column prop="vacationDays" label="Отпуск"></el-table-column>
      <el-table-column prop="planningDays" label="Прогноз оплачиваемых дней"></el-table-column>
      <el-table-column prop="totalVisitDays" label="Всего посещений"></el-table-column>
      <el-table-column prop="recalculationAmount" label="Перерасчет"></el-table-column>
      <el-table-column prop="retentionAmount" label="Корректировка"></el-table-column>
      <el-table-column prop="plannedToAccrue" label="Планируется к начислению"></el-table-column>
      <el-table-column prop="totalToAccrue" label="Итого к начислению"></el-table-column>
      <el-table-column prop="actuallyPaidAmount" label="Фактически оплачено"></el-table-column>
      <el-table-column prop="sendDate" label="Дата и время отправки"></el-table-column>
    </el-table>
  </div>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref} from "vue";
import {
  getPreCalculationAmountRabbitQueue,
  getTimesheetUploadingQueue,
  uploadTimesheetXlsx,
} from "@/services/lmsService";
import {ElMessage} from "element-plus";
import DeleteReasonDialog from "@/components/DeleteReasonDialog.vue";
import {extractApiError} from "@/utils/apiError";
import authService from "@/services/authService";
import {useRouter} from "vue-router";
import {SearchParam} from "@/types/searchParam";
import {
  deleteSelectedTimesheetData,
  getFullTimesheetDetail,
  getFullTimesheetGeneralDetail
} from "@/services/kindergartenService";
import {Kato, KindergartenTimesheetGeneralData, TimesheetType} from "@/types/kindergarten";
import {getGeneratedTimesheetGeneralList, getGeneratedTimesheetList} from "@/services/reportService";
import cacheService from "@/services/cacheService";
import Multiselect from "vue-multiselect";

export default defineComponent({
  name: "TimesheetView",
  components: {Multiselect, DeleteReasonDialog},
  setup() {
    const showModal = ref(false);
    const isLoading = ref(false);
    const fetchLoading = ref(false);
    const uploadedFile = ref<any>();
    const searchParams = ref({
      bin: "",
      kindergartenName: "",
      lmsId: "",
      accountingMonth: new Date().getMonth() + 1,
      accountingYear: new Date().getFullYear(),
      katoCode: "",
    });
    const timesheetGeneralResponse = ref<KindergartenTimesheetGeneralData[]>([]);
    const selectionTimesheetDataList = ref<KindergartenTimesheetGeneralData[]>([]);
    const showDeleteConfirmationModal = ref(false);
    const timesheetType = ref<TimesheetType | null>(null);
    const timesheetTypeList = ref<TimesheetType[]>([]);

    const adminRoles: string[] = authService.getAdminRoles();
    const hasAccess = authService.hasAccess;
    const router = useRouter();

    const katoList = ref<Kato[]>([]);
    const kato = ref<Kato | null>(null);

    const fetchCachedData = async () => {
      // timesheetTypeList.value = await cacheService.useTimesheetType().fetchTimesheetType();
      // timesheetType.value = timesheetTypeList.value.find(item => item.code === 1) || null;
      katoList.value = await cacheService.useKatoStore().fetchKato();
    };

    const openModal = () => {
      showModal.value = true;
    };
    const closeModal = () => {
      showModal.value = false;
    };

    const formattedKatoLabel = (item: any) => {
      return `${item.code} | ${item.nameRu}`;
    };

    const handleSubmit = () => {
      try {
        if (uploadedFile.value) {
          isLoading.value = true;
          const formData = new FormData();
          formData.append('file', uploadedFile.value);
          const timesheetTypeCode = timesheetType.value?.code;
          const accountingMonth = searchParams.value.accountingMonth;
          const accountingYear = searchParams.value.accountingYear;
          if (timesheetTypeCode && accountingMonth && accountingYear) {
            uploadTimesheetXlsx(formData, timesheetTypeCode, accountingMonth, accountingYear).then(() => {
              isLoading.value = false;
              window.location.reload();
            }).catch((error) => {
              if (error.status === 400) {
                ElMessage({
                  message: error.response.data,
                  type: 'error',
                  duration: 0,
                  showClose: true,
                });
              }
              isLoading.value = false;
            })
          }
        }
      } catch (error) {
        isLoading.value = false;
        console.error(error);
      }
    }

    const downloadGeneratedCalculationReportList = async () => {
      try {
        isLoading.value = true;
        const searchParamResponse = new SearchParam(
            0,
            0,
            {
              "bin": searchParams.value.bin,
              "lmsId": searchParams.value.lmsId,
              "accountingMonth": searchParams.value.accountingMonth,
              "accountingYear": searchParams.value.accountingYear,
              "timesheetType": timesheetType.value?.code,
              "kindergartenName": searchParams.value.kindergartenName,
              "katoCode": searchParams.value.katoCode,
            },
            {}
        );

        await getGeneratedTimesheetGeneralList(searchParamResponse);
        isLoading.value = false;
      } catch (error) {
        isLoading.value = false;
        console.error(error);
      }
    }


    const handleFileUpload = (event: any) => {
      uploadedFile.value = event.target.files[0];
    }

    const fetchTimesheetData = async () => {
      try {
        searchParams.value.katoCode = kato.value ? kato.value.code + "" : "";
        if (searchParams.value.bin == "" && searchParams.value.lmsId == "" && searchParams.value.katoCode == "" ) {
          ElMessage.warning("Укажите БИН ДО или LMS ID");
          return;
        }
        fetchLoading.value = true;
        const searchParamResponse = new SearchParam(
            0,
            0,
            {
              "bin": searchParams.value.bin,
              "lmsId": searchParams.value.lmsId,
              "accountingMonth": searchParams.value.accountingMonth,
              "accountingYear": searchParams.value.accountingYear,
              "timesheetType": timesheetType.value?.code,
              "kindergartenName": searchParams.value.kindergartenName,
              "katoCode": searchParams.value.katoCode,
            },
            {}
        );
        timesheetGeneralResponse.value = await getFullTimesheetGeneralDetail(searchParamResponse);
        fetchLoading.value = false;
      } catch (error) {
        fetchLoading.value = false;
        console.error(error);
      }
    };

    const handleSelectionChange = (val: KindergartenTimesheetGeneralData[]) => {
      selectionTimesheetDataList.value = val;
    };

    const handleDeleteSelectedElements = async (reason: string) => {
      if (selectionTimesheetDataList.value.length > 0) {
        fetchLoading.value = true;
        try {
          const responseStatus = await deleteSelectedTimesheetData(selectionTimesheetDataList.value[0].monthlyTimesheetId, selectionTimesheetDataList.value.map(it => it.id), reason);
          if (responseStatus === 200) {
            location.reload();
            return;
          }
          ElMessage({ message: "Неизвестная ошибка, удаление не прошло", type: "error", showClose: true });
        } catch (error) {
          ElMessage({ message: extractApiError(error, "Удаление не прошло"), type: "error", showClose: true });
        }
        fetchLoading.value = false;
        closeDeleteConfirmationModal();
      }
    }

    const closeDeleteConfirmationModal = () => {
      showDeleteConfirmationModal.value = false;
    }

    const formattedTimesheetTypeLabel = (item: any) => {
      return `${item.code} | ${item.name}`;
    }

    onMounted(() => {
      // fetchTimesheetRabbitQueue();
      // fetchPreCalculationAmountRabbitQueue();
      fetchCachedData();
    });

    return {
      timesheetType,
      timesheetTypeList,
      showModal,
      isLoading,
      fetchLoading,
      adminRoles,
      router,
      searchParams,
      timesheetGeneralResponse: timesheetGeneralResponse,
      selectionTimesheetDataList,
      showDeleteConfirmationModal,
      formattedTimesheetTypeLabel,
      hasAccess,
      openModal,
      closeModal,
      handleSubmit,
      handleFileUpload,
      fetchTimesheetData,
      handleSelectionChange,
      handleDeleteSelectedElements,
      downloadGeneratedCalculationReportList,
      kato,
      katoList,
      formattedKatoLabel
    }
  }
});
</script>

<style scoped>
.open-modal-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-modal-btn:hover {
  background-color: #45a049;
}

.modal {
  display: block;
  position: fixed;
  z-index: 5;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

h4 {
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.submit-btn {
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.submit-btn:hover {
  background-color: #45a049;
}

.close-modal-btn {
  margin-top: 10px;
  width: 100%;
  padding: 10px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.close-modal-btn:hover {
  background-color: #e31b0c;
}
</style>
